<template>
  <div class="container">
    <!-- 头部 -->
    <div class="header" :class="{ 'scrolled': isScrolled }">
      <!-- 友情链接 -->
      <a href="https://xingwubazi.com" target="_blank" class="friend-link" title="星武装他字">
        <img src="/assistant.png" alt="星武装他字" class="friend-link-img" />
      </a>
      <div class="header-content">
        <div class="app-info">
          <img v-if="headerInfo && headerInfo.isShow && headerInfo.logo && headerInfo.logo.url"
            class="logo" :src="headerInfo.logo.url" alt="胶佬AI应用平台">
          <div class="brand-wordmark"><span class="title" :style="{'color': headerInfo.nameColor}">{{ headerInfo.name }}</span><span class="brand-tagline">AI生图 · 模型配色 · 取件表</span></div>
        </div>
        <nav class="header-nav" aria-label="首页导航">
          <router-link class="header-paint-link header-square-link" to="/square" aria-label="分享广场"><span class="header-square-icon" aria-hidden="true"><i class="fas fa-layer-group"></i></span><span>分享广场</span></router-link>
          <a class="header-paint-link" href="#paint-color-cards">品牌漆色卡</a>
        </nav>
        <div class="tabs"><NotificationBell />
          <button class="rewards-trigger" :class="{ 'has-reward': rewardPendingCount > 0 && !showRewards }" type="button" aria-haspopup="dialog" aria-controls="home-rewards-dialog" :aria-expanded="showRewards ? 'true' : 'false'" :aria-label="rewardPendingCount ? '签到与活动，有 ' + rewardPendingCount + ' 场活动可领取' : '签到与活动'" @click="openRewards">
            <span class="rewards-gift" aria-hidden="true"><i class="fas fa-gift"></i><b v-if="rewardPendingCount" class="rewards-dot"></b></span><span>签到与活动</span>
          </button>
        <div v-if="username" class="profile-menu">
            <button class="profile-trigger" type="button" :aria-label="displayName + '，用户菜单'">
              <span class="profile-icon"><i class="fas fa-user" aria-hidden="true"></i></span>
              <span class="profile-display-name">{{ displayName }}</span>
            </button>
            <div class="profile-dropdown">
              <button v-if="walletProfile && walletProfile.user && (walletProfile.user.is_admin === true || (walletProfile.user.is_admin == null && walletProfile.user.phone === '13533778129'))" @click="$router.push('/admin')">管理后台</button>
              <button @click="openProfileEditor">个人中心 · 账号与资料</button><router-link to="/square/center?tab=likes">我的点赞与收藏</router-link><router-link to="/square/center?tab=notifications">系统通知</router-link>
              <button @click="openContactSection">联系站长</button>
              <button @click="relogin">退出登录</button>
            </div>
          </div>
          <div v-else @click="tologin" class="tab-item login-btn">
            <span class="login-prefix">未登录 ·&nbsp;</span>登录
          </div>
        </div>
      </div>
    </div>

    <RewardsCenter v-if="username" ref="rewardsCenter" :visible="showRewards" :summary="walletProfile && walletProfile.usage_cards || {}" @close="showRewards = false" @updated="updateCampaignCards" @pending-change="rewardPendingCount = $event" />

    <AccountProfileDialog v-if="showProfileModal" @close="showProfileModal = false" @updated="fetchWalletProfile" />

    <!-- 邀请码提示弹窗 -->
    <div v-if="showInviteModal" class="invite-modal-overlay" @click.self="showInviteModal = false">
      <div class="invite-modal">
        <div class="invite-modal-header">
          <h3>⚠️ 请先填写邀请码</h3>
          <button class="close-btn" @click="showInviteModal = false">×</button>
        </div>
        <div class="invite-modal-body">
          <p>您还没有填写邀请码，无法使用此功能。</p>
          <p>请联系站长获取邀请码：</p>
          <div class="contact-info">
            <div class="contact-item">
              <span class="contact-label">📱 抖音：</span>
              <span>{{ appIntroduce.content }}</span>
            </div>
            <div class="qrcode-container">
              <img :src="appIntroduce.showImg" alt="抖音二维码" class="modal-qrcode">
              <p class="qrcode-tip">抖音扫码关注</p>
            </div>
          </div>
          <div class="invite-modal-actions">
            <button class="primary-btn" @click="goToProfile">去填写邀请码</button>
            <button class="secondary-btn" @click="showInviteModal = false">稍后再说</button>
          </div>
        </div>
      </div>
    </div>

    <section id="row0" class="white-hero" aria-label="模型创作与品牌合作">
      <HomeHeroCarousel @contact="openContactSection" />
      <div class="workspace-entry-heading">
        <h2>选择功能，开始创作</h2>
        <p id="workspace-entry-hint">点击下方任意功能卡片，进入对应工作区</p>
      </div>
      <nav class="hero-workspaces" aria-label="模型创作工作区" aria-describedby="workspace-entry-hint">
        <button type="button" @click="checktopage">
          <img src="/images/mecha-parts.webp" alt="" width="64" height="64">
          <span><b>取件表制作</b><small>识别说明书，生成取件清单</small><em>点击进入 <i class="fas fa-arrow-right" aria-hidden="true"></i></em></span>
        </button>
        <button type="button" @click="checktoAiColoringList">
          <img src="/images/mecha-paint.webp" alt="" width="64" height="64">
          <span><b>AI 上色</b><small>上传线稿，填色并预览涂装</small><em>点击进入 <i class="fas fa-arrow-right" aria-hidden="true"></i></em></span>
        </button>
        <button type="button" @click="checktoExtremeColor">
          <img src="/images/mecha-armor.webp" alt="" width="64" height="64">
          <span><b>极致分色</b><small>上传部件图，生成精细分色</small><em>点击进入 <i class="fas fa-arrow-right" aria-hidden="true"></i></em></span>
        </button>
        <button type="button" @click="checktoImageGenerator">
          <img src="/images/mecha-helmet.webp" alt="" width="64" height="64">
          <span><b>AI 生图</b><small>输入提示词，生成参考效果图</small><em>点击进入 <i class="fas fa-arrow-right" aria-hidden="true"></i></em></span>
        </button>
        <button type="button" @click="checktoInspirationBoard">
          <img src="/images/mecha-board.webp" alt="" width="64" height="64">
          <span><b>灵感画板</b><small>组合素材，预览模型改造</small><em>点击进入 <i class="fas fa-arrow-right" aria-hidden="true"></i></em></span>
        </button>
      </nav>
      <p class="public-guide-entry">第一次使用？<a href="/features/index.html">先看五个功能的用途、教程与案例 →</a><span>无需登录</span><a href="#paint-color-cards">品牌漆色卡与相近色查询 ↓</a></p>
    </section>

    <main class="scroll-view" ref="scrollView">
      <section class="capability-intro" aria-labelledby="capability-title">
        <div class="intro-copy">
          <span class="section-kicker">MODEL WORKFLOW</span>
          <h2 id="capability-title">从说明书整理到成品方案，一套工具完成模型创作</h2>
          <p>五个工作区覆盖零件统计、线稿配色、极致分色、图片生成与素材排版，创作记录可持续保存和回看。</p>
        </div>
      </section>

      <section id="row1" class="section workflow-section">
        <div class="product-section-heading">
          <div>
            <span class="section-kicker">01 · 取件表</span>
            <h2>取件表制作</h2>
            <p>上传 PDF 拼装说明书，识别页内零件编号并整理成可核对的取件清单。</p>
            <a class="feature-guide-link" href="/features/parts-list.html">了解取件表用途、操作步骤与案例 →</a>
          </div>
          <button class="section-action" type="button" @click="checktopage">
            开始制作 <i class="fas fa-arrow-right"></i>
          </button>
        </div>
        <div class="ds-steps">
          <article v-for="(step, index) in steps" :key="index" class="ds-step" @mouseover="handleStepHover(index)">
            <div class="ds-step-media">
              <img class="ds-step-image" :src="step.image" :alt="step.title">
              <span class="ds-step-index">0{{ index + 1 }}</span>
            </div>
            <div class="ds-step-content">
              <h3>{{ step.title }}</h3>
              <span class="ds-step-description">{{ step.description }}</span>
            </div>
          </article>
        </div>
      </section>

      <section class="section workflow-section coloring-workflow">
        <div class="product-section-heading">
          <div>
            <span class="section-kicker">02 · 配色研究</span>
            <h2>AI 上色任务</h2>
            <p>在线稿上试配颜色、管理厂家油漆，并生成更接近实际涂装的效果预览。</p>
            <a class="feature-guide-link" href="/features/line-coloring.html">了解线稿上色用途、操作步骤与案例 →</a>
          </div>
          <button class="section-action" type="button" @click="checktoAiColoringList">
            新建上色任务 <i class="fas fa-arrow-right"></i>
          </button>
        </div>
        <div class="ds-steps">
          <article v-for="(step, index) in colorsteps" :key="index" class="ds-step" @mouseover="handleStepHover(index)">
            <div class="ds-step-media">
              <img class="ds-step-image" :src="step.image" :alt="step.title">
              <span class="ds-step-index">0{{ index + 1 }}</span>
            </div>
            <div class="ds-step-content">
              <h3>{{ step.title }}</h3>
              <span class="ds-step-description">{{ step.description }}</span>
            </div>
          </article>
        </div>
      </section>

      <section class="section showcase-section extreme-color-section">
        <div class="showcase-grid">
          <div class="showcase-visual extreme-color-visual">
            <img src="/images/mecha-armor.webp" alt="红白蓝装甲与液压结构分色示意">
            <div class="visual-meta visual-meta-top"><i class="fas fa-layer-group"></i> 面板层级 · 硬边分离</div>
            <div class="visual-meta visual-meta-bottom">部件 + 风格 + 专属色板</div>
          </div>
          <div class="showcase-copy">
            <span class="section-kicker">03 · 极致分色</span>
            <h2>把每一块装甲、内构和功能细节，拆成可执行的专业涂装方案</h2>
            <p class="showcase-lead">上传模型部件照片，自动提取结构线稿，并按部件与风格匹配参考作品。选择主色、辅助色和点缀色，主色支持自选颜色与品牌漆色卡。</p>
            <a class="feature-guide-link" href="/features/extreme-color.html">了解极致分色用途、操作步骤与案例 →</a>
            <div class="feature-list">
              <div><i class="fas fa-bezier-curve"></i><span><b>结构线稿</b><small>保留轮廓、刻线与机械层级</small></span></div>
              <div><i class="fas fa-magnifying-glass"></i><span><b>参考匹配</b><small>按部件和风格检索分色作品</small></span></div>
              <div><i class="fas fa-swatchbook"></i><span><b>多级色调</b><small>主色、辅助色与点缀色多选</small></span></div>
              <div><i class="fas fa-box-archive"></i><span><b>作品归档</b><small>保留原图、线稿、设置与结果</small></span></div>
            </div>
            <button class="showcase-action extreme-color-action" type="button" @click="checktoExtremeColor">
              <i class="fas fa-wand-magic-sparkles"></i> 开始极致分色
            </button>
          </div>
        </div>
      </section>

      <section id="row2" class="section showcase-section ai-generator-section">
        <div class="showcase-grid">
          <div class="showcase-visual generation-visual">
            <img src="/images/mecha-helmet.webp" alt="AI 生成的模型涂装效果预览">
            <div class="visual-meta visual-meta-top"><i class="fas fa-wand-magic-sparkles"></i> 参考图 + 提示词</div>
            <div class="visual-meta visual-meta-bottom">1K / 2K · 多种画幅</div>
          </div>
          <div class="showcase-copy">
            <span class="section-kicker">04 · AI 生图</span>
            <h2>对接顶尖图像大模型，把你的思路秒变参考效果图</h2>
            <p class="showcase-lead">支持文字生成与参考图生成，可按项目保存多轮结果。在正式喷涂前，先快速验证颜色、材质和场景方向。</p>
            <a class="feature-guide-link" href="/features/ai-image.html">了解AI生图用途、提示词与案例 →</a>
            <div class="feature-list">
              <div><i class="fas fa-images"></i><span><b>多图参考</b><small>组合多张素材约束造型与风格</small></span></div>
              <div><i class="fas fa-maximize"></i><span><b>多种比例</b><small>适配头像、展示图与宽幅场景</small></span></div>
              <div><i class="fas fa-clock-rotate-left"></i><span><b>项目记录</b><small>保留提示词、参考图与生成结果</small></span></div>
              <div><i class="fas fa-gauge-high"></i><span><b>1K / 2K</b><small>按用途选择清晰度与生成成本</small></span></div>
            </div>
            <button class="showcase-action" type="button" @click="checktoImageGenerator">
              <i class="fas fa-wand-magic-sparkles"></i> 打开 AI 生图
            </button>
          </div>
        </div>
      </section>

      <section class="section showcase-section inspiration-section">
        <div class="showcase-grid reverse">
          <div class="showcase-visual board-visual">
            <div class="board-preview-toolbar">
              <span><i class="fas fa-plus"></i> 素材</span>
              <span><i class="fas fa-pen-ruler"></i> 绘图</span>
              <span><i class="fas fa-scissors"></i> 抠图</span>
              <b>100%</b>
            </div>
            <div class="board-preview-body">
              <div class="board-preview-canvas">
                <img :src="require('@/assets/images/INSPIRATION BOARD.png')" alt="灵感画板素材编辑预览">
                <span class="canvas-selection"></span>
              </div>
              <div class="board-preview-layers">
                <strong>图层</strong>
                <span class="active"><i></i>主体抠图</span>
                <span><i></i>配色参考</span>
                <span><i></i>结构线稿</span>
              </div>
            </div>
          </div>
          <div class="showcase-copy">
            <span class="section-kicker">05 · 灵感画板</span>
            <h2>AI 抠图组合，快速预览你的改造效果</h2>
            <p class="showcase-lead">多张素材按图层管理，选中的图层可独立移动、翻转、复制和擦除，再直接作为 AI 生图参考。</p>
            <a class="feature-guide-link" href="/features/inspiration-board.html">了解灵感画板用途、操作步骤与案例 →</a>
            <div class="feature-list">
              <div><i class="fas fa-layer-group"></i><span><b>独立图层</b><small>素材与抠图结果分层管理</small></span></div>
              <div><i class="fas fa-scissors"></i><span><b>智能抠图</b><small>快速提取主体或涂抹指定区域</small></span></div>
              <div><i class="fas fa-draw-polygon"></i><span><b>CAD 绘线</b><small>直线、圆弧、椭圆与放样曲线</small></span></div>
              <div><i class="fas fa-box-archive"></i><span><b>画板归档</b><small>保存图层结构，随时继续编辑</small></span></div>
            </div>
            <button class="showcase-action board-action" type="button" @click="checktoInspirationBoard">
              <i class="fas fa-layer-group"></i> 打开灵感画板
            </button>
          </div>
        </div>
      </section>

      <PaintColorCatalog />

      <section id="row3" class="community-band">
        <div>
          <span class="section-kicker">CREATOR COMMUNITY</span>
          <h2>{{ appIntroduce.slogan.replace('💬 ', '') }}</h2>
          <p>{{ appIntroduce.content.replace('📱 ', '') }} · 获取更新、邀请码与使用支持</p>
        </div>
        <div class="community-contact">
          <img class="qrcode-image" :src="appIntroduce.showImg" alt="抖音联系二维码" @error="$event.target.src = '/assistant.png'">
          <span>扫码联系站长</span>
        </div>
      </section>

      <section id="row4" class="section project-section">
        <div class="product-section-heading project-heading">
          <div>
            <span class="section-kicker">BUILD LOG</span>
            <h2>项目进度</h2>
            <p>围绕模型玩家的实际工作流持续迭代，每一次更新都对应一个可直接使用的能力。</p>
          </div>
          <span class="project-status"><i></i> 持续更新中</span>
        </div>
        <div class="project-timeline">
          <article v-for="(milestone, index) in projectMilestones" :key="index" class="milestone" :class="{ upcoming: !milestone.completed }">
            <div class="milestone-rail">
              <span class="milestone-dot" :class="{'active': milestone.completed}"></span>
              <span class="milestone-index">{{ String(index + 1).padStart(2, '0') }}</span>
            </div>
            <div class="milestone-content">
              <div class="milestone-date">{{ milestone.date }}</div>
              <h3 class="milestone-title">{{ milestone.title }}</h3>
              <p class="milestone-description">{{ milestone.description }}</p>
            </div>
          </article>
        </div>
      </section>
    </main>
    
    <!-- 页脚 -->
    <div class="footer">
      <p>地球联邦军 © 2023 版权所有</p>
      <p>技术支持：阿纳海姆电子公司 | 粤ICP备2026000017号-1 | 中山祖艺模玩</p>
    </div>
  </div>
</template>

<script>
import AccountProfileDialog from "@/components/AccountProfileDialog.vue"
import NotificationBell from '@/components/NotificationBell.vue'
import { clearAuthSession, showToast, navigateTo, getStorageSync, setStorageSync } from '@/utils/uni-app'
import api from '@/api'
import RewardsCenter from '@/components/RewardsCenter.vue'
import HomeHeroCarousel from '@/components/HomeHeroCarousel.vue'
import PaintColorCatalog from '@/components/PaintColorCatalog.vue'

export default {
  name: 'HomePage',
  components: { NotificationBell, AccountProfileDialog, RewardsCenter, HomeHeroCarousel, PaintColorCatalog },
  data() {
    return {
      page: 1,
      showRewards: false,
      rewardPendingCount: 0,
      subject: "",
      keyword: "",
      total: 1000,
      pageSize: 10,
      array: ["全部", "MG", "MG 1", "RG 1", "RG限定", "PGU", "PG限定"],
      subjectindex: 0,
      currentId: '',
      posterWidth: "180",
      posterHeight: '',
      showMob: false,
      activeIndex: 0,
      offsetTops: [],
      lock: false,
      headerInfo: {
        "_id": "header",
        "logo": {
          "extname": "23",
          "name": "255",
          "url": "/logo.png"
        },
        "name": "胶佬AI应用平台",
        "nameColor": "#543",
        "tabbar": ["🏠 首页", "📖 使用指南", "📞 联系站点"],
        "tabColor": "#543",
        "headerBackground": "https://www.mynew-miracle.com/Application/Tpl/App/default/Index/homepage/static/img/03.1bcdb4d.jpg",
        "titleColor": "#00aaff",
        "isShow": true
      },
      // 轮播数据
      posterData: [{
        "title": "",
        "iconUrl": "/bannericon.png",
        "titleImage": "/title.png",
        "subTitle": "",
        "isVideo": true,
        "videoUrl": "https://agamaship.com/agamashipdiv.mp4",
        "open_url": "#",
        "titleColor": "#ffffff",
        "subTitleColor": "#ffffff",
        "bannerBackground": "#000000"
      }],
      // 下载
      downloadInfo: [{
        "open_url": "http://zhushou.360.cn/",
        "name": "MGEX强袭自由",
        "author": "作者",
        "subject": "MG",
        "type": "default",
        "status": "未下载",
        "bannerfile": {
          "url": "https://www.mynew-miracle.com/Application/Tpl/App/default/Index/homepage/static/img/03.1bcdb4d.jpg"
        }
      }],
      // 联系信息
      appIntroduce: {
        "slogan": "💬 打破想象边界，重塑模型未来！",
        "content": "📱 未老年模型玩家彩霞爸爸",
        "showImg": "/3f02435cce8a0fdc58197f18309ccee2.jpg",
      },
      // 项目进展
      projectMilestones: [
        {
          date: '2024年11月18日',
          title: '取件表生成工具项目启动',
          description: '项目正式启动，开始需求分析与技术选型',
          completed: true
        },
        {
          date: '2025年2月',
          title: '取件表生成功能正式上线',
          description: '经过三个月的开发与测试，取件表生成功能正式发布上线',
          completed: true
        },
        {
          date: '2025年9月',
          title: 'AI上色预览功能启动',
          description: '启动AI上色预览功能开发，引入先进的图像处理技术',
          completed: true
        },
        {
          date: '2025年10月',
          title: 'AI上色预览功能上线',
          description: '线稿填色、颜色归档与涂装效果预览正式开放使用',
          completed: true
        },
        {
          date: '2026年',
          title: 'AI 生图工作区上线',
          description: '加入项目归档、多图参考、1K / 2K 生成与多画幅输出能力',
          completed: true
        },
        {
          date: '2026年7月',
          title: '灵感画板进入创作流程',
          description: '上线图层管理、智能抠图、橡皮擦、CAD 绘线与画板归档',
          completed: true
        },
        {
          date: '2026年9月',
          title: '极致分色完成',
          description: '完成部件线稿提取、精细分色、个人参考库与作品归档功能',
          completed: true
        },
        {
          date: '2026年10月17日',
          title: '平台正式更名为胶佬AI应用平台',
          description: '统一平台名称与功能说明，面向高达与拼装模型玩家提供AI生图、模型配色、取件表与灵感画板工具，并增加无需登录的公开功能介绍、教程与案例。',
          completed: true
        },
        {
          date: '后续项目',
          title: '刻线效果预览',
          description: '计划加入刻线效果预览，帮助提前查看模型刻线方案',
          completed: false
        }
      ],
      isScrolled: false,
      aboutus: {
        "beianhao": "",
        "beianhaoUrl": "",
        "beiandi": "",
        "beiandiUrl": "https://www.mynew-miracle.com/Application/Tpl/App/default/Index/homepage/static/img/03.1bcdb4d.jpg",
        "copyright": "",
        "footColor": "#f45534"
      },
      username: "",
      steps: [
        { title: '新建模型任务', description: '上传 PDF 拼装说明书并填写模型信息', image: require('@/assets/images/step1.png') },
        { title: '识别零件编号', description: '选择需要处理的页码，核对系统识别结果', image: require('@/assets/images/step2.png') },
        { title: '整理取件清单', description: '按部件与零件号汇总，生成便于核对的清单', image: require('@/assets/images/step3.png') }
      ],
      colorsteps: [
        { title: '上传线稿', description: '建立上色任务并导入模型线稿或参考图', image: require('@/assets/images/colorstep1.png') },
        { title: '编辑配色', description: '使用填充、画笔与厂家油漆色库完成配色', image: require('@/assets/images/colorstep2.png') },
        { title: '生成效果', description: '预览真实材质与光照下的模型涂装效果', image: require('@/assets/images/colorstep3.png') }
      ],
      activeStep: 0,
      showProfileMenu: false,
      showProfileModal: false,
      showInviteModal: false,
      walletProfile: null,
      profileForm: {
        phone: '',
        name: '',
        dyid: '',
        inviteCode: ''
      }
    }
  },
  computed: {
    displayName() {
      const raw = this.walletProfile?.user?.name || this.username || '个人中心'
      return this.maskAccount(raw)
    }
  },
  watch: { username(value) { if (!value) { this.showRewards = false; this.rewardPendingCount = 0 } } },
  mounted() {
    //this.getDownload(1)
    const token = getStorageSync('token')
    this.username = token ? (getStorageSync('username') || '已登录') : ''
    if (token) {
      this.fetchWalletProfile()
    }
    window.addEventListener('scroll', this.handleScroll)
    window.addEventListener('auth-session-changed', this.handleAuthSessionChanged)
    window.addEventListener('focus', this.refreshCheckInStatus)
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll)
    window.removeEventListener('auth-session-changed', this.handleAuthSessionChanged)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
    window.removeEventListener('focus', this.refreshCheckInStatus)
    window.removeEventListener('auth-session-changed', this.handleAuthSessionChanged)
  },
  methods: {
    updateCampaignCards(summary) { if (!this.walletProfile) this.walletProfile = {}; this.$set(this.walletProfile, 'usage_cards', summary) },
    refreshCheckInStatus() { if (getStorageSync('token')) this.fetchWalletProfile() },
    openRewards() { if (!this.username) { navigateTo('/login'); return } this.showRewards = true },
    maskAccount(value) {
      if (value === null || value === undefined) return ''
      const str = String(value)
      const mask = (s) => {
        if (s.length <= 6) return s
        const start = s.slice(0, Math.floor((s.length - 4) / 2))
        const end = s.slice(s.length - Math.ceil((s.length - 4) / 2))
        return start + '****' + end
      }
      if (/^\d+$/.test(str)) return mask(str)
      return str.replace(/\d+/g, (m) => mask(m))
    },
    setBannerPlaybackRate(event) {
      event.currentTarget.playbackRate = 0.3
    },
    handleAuthSessionChanged(event) {
      if (!event.detail?.authenticated) {
        this.showRewards = false
        this.rewardPendingCount = 0
        this.username = ''
        this.walletProfile = null
        this.showProfileModal = false
        this.showProfileMenu = false
      }
    },
    handleScroll() {
      this.isScrolled = window.scrollY > 50
    },
    handleStepHover(index) {
      this.activeStep = index
    },
    search(res) {
      this.keyword = res.value
      this.page = 1
      this.getDownload(1)
    },
    bindPickerChange(e) {
      console.log('picker发送选择改变，携带值为', e.target.value)
      this.subjectindex = e.target.value
      this.subject = this.array[e.target.value]
      this.page = 1
      this.getDownload(1)
    },
    change(e) {
      console.log(e)
      this.current = e.current
      this.getDownload(e.current)
    },
    checktopage() {
      this.enterWorkspace('/paperlist')
    },
    checktopaint() {
      navigateTo("/painter")
    },
    checktoAiColoringList() {
      this.enterWorkspace('/ai-coloring-list')
    },
    checktoImageGenerator() {
      this.enterWorkspace('/image-generator')
    },
    checktoExtremeColor() {
      this.enterWorkspace('/extreme-color')
    },
    checktoInspirationBoard() {
      this.enterWorkspace('/image-generator?mode=board')
    },
    enterWorkspace(path) {
      if (!getStorageSync('token')) {
        this.showInviteModal = false
        navigateTo('/login')
        return
      }
      navigateTo(path)
    },
    goToProfile() {
      this.showInviteModal = false
      this.showProfileModal = true
    },
    tologin() {
      navigateTo("/login")
    },
    async fetchWalletProfile() {
      try {
        const res = await api({ method: 'get', url: '/liner/wallet/profile' })
        if (res.code === 200 || res.code === '200') {
          this.walletProfile = res.data
          this.$refs.rewardsCenter?.refresh()
          this.username = res.data.user?.email || res.data.user?.phone || res.data.user?.name || this.username
          setStorageSync('username', this.username)
          this.profileForm = {
            phone: res.data.user?.phone || '',
            name: res.data.user?.name || '',
            dyid: res.data.user?.dyid || '',
            inviteCode: res.data.user?.invite_code || ''
          }
        }
      } catch (e) {
        console.warn('获取个人中心失败', e)
        this.username = ''
        this.walletProfile = null
      }
    },
    openProfileEditor() {
      this.showProfileMenu = false
      this.showProfileModal = true
    },
    openContactSection() {
      this.showProfileMenu = false
      this.scrollTo(3)
    },
    async saveProfile() {
      try {
        const res = await api({
          method: 'put',
          url: '/liner/profile',
          data: {
            name: this.profileForm.name,
            dyid: this.profileForm.dyid,
            invite_code: this.profileForm.inviteCode
          }
        })
        if (res.code === 200 || res.code === '200') {
          showToast({ title: '保存成功', duration: 1500 })
          this.showProfileModal = false
          await this.fetchWalletProfile()
        } else {
          showToast({ title: res.msg || '保存失败', duration: 2000 })
        }
      } catch (e) {
        showToast({ title: '保存失败', duration: 2000 })
      }
    },
    loadImg(e) {
      console.log("e:----loadImg ", e);
    },
    getConfig() {
      // 在Vue2中，可以通过API获取配置
    },
    getBanner() {
      // 在Vue2中，可以通过API获取轮播图
    },
    relogin() {
      clearAuthSession()
      this.username = ""
      this.walletProfile = null
      this.showProfileMenu = false
      // 不跳转到登录页面，只清空token和username
    },
    getDownload(page) {
      api.formPost('/liner/Gethomepagelist', {
        page: page,
        keyword: this.keyword,
        subject: this.subject,
      })
        .then(res => {
          let data = res.data
          if (data.code == 200) {
            console.log(data.data)
            this.downloadInfo = data.data
            this.total = data.total
          } else {
            showToast("获取失败")
          }
        })
        .catch(_err => {
          showToast("获取失败")
        })
    },
    downloadType(type) {
      switch (type) {
        case 0:
          return 'H5'
          break;
        case 1:
          return 'Android'
          break;
        case 2:
          return 'ios'
          break;
        case 3:
          return '小程序'
          break;
        default:
          break;
      }
    },
    toUrl(item) {
      if (item.open_url) {
        window.open(item.open_url)
      }
    },
    openUrl(url) {
      window.open(url);
    },
    scrollTo(index) {
      this.activeIndex = index
      this.currentId = 'row' + index;
      const element = document.getElementById(this.currentId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }
}
</script>

<style scoped>
.container {
  padding: 0 15px 15px 15px;
  background-color: #f9f9ff;
  border-radius: 0;
  box-shadow: none;
  min-height: 100vh;
}

/* 头部 */
.header {
  padding: 10px clamp(40px, 6vw, 104px);
  border-radius: 0;
  margin-bottom: 0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background: transparent;
  transition: background 0.3s ease;
}

.header.scrolled {
  background: rgba(0, 0, 0, 0.8);
}

.header .title,
.header .tab-item,
.header .profile-trigger,
.header .login-btn,
.header .login-button {
  color: var(--mecha-ink) !important;
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  position: relative;
  width: 100%;
  max-width: 1600px;
  margin: 0 auto;
}

.app-info {
  display: flex;
  align-items: center;
  gap: 15px;
  min-width: 0;
}

.logo {
  width: 50px;
  height: 50px;
  border-radius: 10px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}

.title {
  font-size: 24px;
  font-weight: bold;
  color: #6a5acd;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.brand-wordmark { display:flex; flex-direction:column; gap:3px; min-width:0; }
.brand-wordmark .title { line-height:1.2; }
.brand-tagline { color:#52627a; font-size:12px; line-height:1.4; white-space:nowrap; }

.tabs {
  display: flex;
  gap: 6px;
  flex-wrap: nowrap;
  justify-content: flex-end;
  align-items: center;
  max-width: 72%;
}

.tab-item {
  position: relative;
  height: 38px;
  padding: 0 12px;
  border-radius: 8px;
  background: transparent;
  color: #44356f;
  cursor: pointer;
  transition: background-color 0.2s ease, color 0.2s ease;
  font-weight: 600;
  white-space: nowrap;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.tab-item::after {
  content: '';
  position: absolute;
  left: 12px;
  right: 12px;
  bottom: 4px;
  height: 2px;
  border-radius: 999px;
  background: #6a5acd;
  transform: scaleX(0);
  transform-origin: center;
  transition: transform 0.22s ease;
}

.tab-item:hover {
  background: rgba(106, 90, 205, 0.1);
  color: #4d3db2;
}

.tab-item:hover::after {
  transform: scaleX(1);
}

.login-button {
  color: #44356f !important;
}

.login-button:hover {
  background: rgba(106, 90, 205, 0.1);
  color: #4d3db2 !important;
}

.login-btn, .logout-btn {
  background: transparent;
  color: #44356f;
  cursor: pointer;
  transition: background-color 0.2s ease, color 0.2s ease;
  font-weight: 600;
}

.login-btn:hover, .logout-btn:hover {
  background: rgba(106, 90, 205, 0.1);
  color: #4d3db2;
}

.profile-menu {
  position: relative;
  display: flex;
  align-items: stretch;
  height: 46px;
  padding: 4px 0;
  box-sizing: border-box;
}

.profile-trigger {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 38px;
  max-width: 220px;
  padding: 0 12px;
  border: none;
  border-radius: 8px;
  background: transparent;
  color: #44356f;
  cursor: pointer;
  font-weight: 600;
  transition: background-color 0.2s ease, color 0.2s ease;
}

.profile-trigger::after {
  content: '';
  position: absolute;
  left: 12px;
  right: 12px;
  bottom: 4px;
  height: 2px;
  border-radius: 999px;
  background: #6a5acd;
  transform: scaleX(0);
  transform-origin: center;
  transition: transform 0.22s ease;
}

.profile-menu:hover .profile-trigger,
.profile-trigger:focus {
  background: rgba(106, 90, 205, 0.1);
  color: #4d3db2;
}

.profile-menu:hover .profile-trigger::after,
.profile-trigger:focus::after {
  transform: scaleX(1);
}

.profile-trigger span:first-child {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.profile-dropdown {
  position: absolute;
  right: 0;
  top: calc(100% - 4px);
  width: 172px;
  padding: 6px;
  background: #fff;
  border: 1px solid #e8e8ff;
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  z-index: 20;
  opacity: 0;
  visibility: hidden;
  transform: translateY(6px);
  pointer-events: none;
  transition: opacity 0.3s ease 0.2s, transform 0.3s ease 0.2s, visibility 0.3s ease 0.2s;
}

.profile-menu:hover .profile-dropdown,
.profile-menu:focus-within .profile-dropdown {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
  pointer-events: auto;
  transition-delay: 0s;
}

.profile-dropdown button {
  width: 100%;
  padding: 9px 10px;
  border: none;
  background: transparent;
  color: #333;
  text-align: left;
  cursor: pointer;
  border-radius: 6px;
}

.profile-dropdown button:hover {
  background: #f0f0ff;
  color: #6a5acd;
}

.account-modal {
  position: fixed;
  inset: 0;
  z-index: 1000;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.account-panel {
  width: min(420px, 94vw);
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 16px 40px rgba(0, 0, 0, 0.18);
  padding: 18px;
}

.wallet-panel {
  width: min(620px, 94vw);
}

.account-panel-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.account-panel-header h3 {
  margin: 0;
  color: #333;
}

.account-panel-header button {
  width: 30px;
  height: 30px;
  border: none;
  border-radius: 6px;
  background: #f0f0ff;
  cursor: pointer;
}

.account-form {
  display: grid;
  gap: 8px;
}

.account-form label {
  font-size: 13px;
  color: #666;
}

.account-form input,
.recharge-row input {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #e8e8ff;
  border-radius: 8px;
  outline: none;
}

.account-form input.input-disabled {
  background-color: #f5f5f5;
  color: #999;
  cursor: not-allowed;
}

.account-actions,
.recharge-row {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 16px;
}

.account-actions button,
.recharge-row button {
  padding: 9px 16px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
}

.account-actions .primary,
.recharge-row .primary {
  background: #6a5acd;
  color: #fff;
}

.wallet-summary {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px;
  border-radius: 10px;
  background: #f8f7ff;
  color: #333;
}

.wallet-summary strong {
  color: #6a5acd;
  font-size: 22px;
}

.order-list {
  margin-top: 16px;
  max-height: 320px;
  overflow-y: auto;
  border-top: 1px solid #eee;
}

.order-item {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 0;
  border-bottom: 1px solid #eee;
  color: #333;
}

.order-item div:first-child {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.order-item span {
  color: #888;
  font-size: 12px;
}

.income {
  color: #18a058;
  font-weight: 700;
}

.expense {
  color: #d03050;
  font-weight: 700;
}

.empty-orders {
  padding: 24px;
  text-align: center;
  color: #999;
}

.scroll-view {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding-top: 80px;
}

.section {
  margin-bottom: 30px;
  padding: 20px;
  background-color: white;
  border-radius: 15px;
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.05);
}

.section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 2px solid #e8e8ff;
}

.section-title {
  font-size: 1.5em;
  font-weight: bold;
  color: #6a5acd;
  padding: 5px 15px;
  background-color: #f0f0ff;
  border-radius: 20px;
  display: inline-block;
}

.section-divider {
  width: 100px;
  height: 3px;
  background: linear-gradient(to right, #6a5acd, #ff9eb5);
  border-radius: 3px;
}

/* 轮播 */
.carousel-wrapper {
  position: relative;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  border-radius: 0;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
}

.carousel-wrapper-full {
  position: relative;
  width: 100% !important;
  height: 100vh;
  overflow: hidden;
  margin-top: 0 !important;
}

.carousel {
  width: 100%;
  height: 100%;
  position: relative;
}

.carousel-item {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  transition: opacity 0.8s ease-in-out;
  display: flex;
  align-items: center;
  justify-content: center;
}

.carousel-item.active {
  opacity: 1;
}

.carousel-video, .carousel-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100% !important;
  height: 100% !important;
  min-width: 100%;
  min-height: 100%;
  max-width: none;
  max-height: none;
  object-fit: cover !important;
  object-position: center center;
}

.carousel-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, rgba(0,0,0,0.6) 0%, rgba(0,0,0,0.3) 50%, rgba(0,0,0,0.6) 100%);
  pointer-events: none;
}

.carousel-content {
  position: relative;
  z-index: 10;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: 20px 40px;
  width: min(920px, calc(100% - 32px));
}

.banner-nav {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 12px;
  width: min(720px, 100%);
  margin-top: 4px;
}

.banner-nav-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 7px;
  min-width: 0;
  min-height: 72px;
  padding: 11px 14px;
  background: rgba(12, 18, 32, 0.5);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 8px;
  color: #fff;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  font: inherit;
  font-size: 14px;
  font-weight: 600;
}

.banner-nav-item:hover {
  background: rgba(255, 255, 255, 0.2);
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(0, 200, 255, 0.3);
}

.banner-nav-icon {
  font-size: 22px;
}

.profile-icon {
  margin-right: 6px;
  font-size: 16px;
}

.carousel-title {
  font-size: 4em;
  font-weight: bold;
  margin-bottom: 20px;
  color: #fff;
  text-shadow: 0 0 20px rgba(255, 255, 255, 0.5);
  letter-spacing: 8px;
  transform: scaleY(1);
}

.banner-icon {
  width: 150px;
  height: auto;
  margin-bottom: 20px;
}

.banner-title-image {
  width: 400px;
  height: auto;
  margin-bottom: 20px;
  position: relative;
  border-radius: 12px;
  backdrop-filter: blur(1px);
  -webkit-backdrop-filter: blur(1px);
  background: linear-gradient(135deg,hsla(0,0%,20%,.1),hsla(0,0%,30%,.05) 20%,hsla(0,0%,20%,.1));
  border: 1px solid rgba(255, 255, 255, 0.2);
  box-shadow: 
    0 8px 32px rgba(0, 0, 0, 0.3),
    inset 0 1px 0 rgba(255, 255, 255, 0.2),
    0 0 60px rgba(0, 200, 255, 0.3),
    0 0 100px rgba(255, 0, 200, 0.2);
  animation: cyberpunkGlow 3s ease-in-out infinite alternate;
}

@keyframes cyberpunkGlow {
  0% {
    box-shadow: 
      0 8px 32px rgba(0, 0, 0, 0.3),
      inset 0 1px 0 rgba(255, 255, 255, 0.2),
      0 0 60px rgba(0, 200, 255, 0.3),
      0 0 100px rgba(255, 0, 200, 0.2);
  }
  100% {
    box-shadow: 
      0 8px 32px rgba(0, 0, 0, 0.3),
      inset 0 1px 0 rgba(255, 255, 255, 0.2),
      0 0 80px rgba(0, 200, 255, 0.5),
      0 0 120px rgba(255, 0, 200, 0.4);
  }
}

.banner-title-image::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 50%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.2),
    transparent
  );
  animation: lightSweep 4s linear infinite;
  pointer-events: none;
}

@keyframes lightSweep {
  0% {
    left: -100%;
  }
  100% {
    left: 200%;
  }
}

.carousel-text {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.carousel-title::after {
  content: attr(data-text);
  position: absolute;
  left: 0;
  right: 0;
  top: 100%;
  color: rgba(255, 255, 255, 0.3);
  text-shadow: 0 -2px 10px rgba(255, 255, 255, 0.3);
  transform: scaleY(-1);
  background: linear-gradient(to bottom, transparent, rgba(0, 0, 0, 0.3));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  pointer-events: none;
}

.carousel-subtitle {
  font-size: 1.8em;
  color: #fff;
  text-shadow: 0 0 15px rgba(255, 255, 255, 0.5);
  letter-spacing: 2px;
}

/* 轮播指示器 */
.carousel-indicators {
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 10px;
  z-index: 20;
}

.indicator {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.5);
  cursor: pointer;
  transition: all 0.3s;
}

.indicator.active {
  background: #fff;
  transform: scale(1.2);
}

/* 轮播控制按钮 */
.carousel-btn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 50px;
  height: 50px;
  border: none;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  color: #fff;
  font-size: 24px;
  cursor: pointer;
  z-index: 20;
  transition: all 0.3s;
  backdrop-filter: blur(5px);
}

.carousel-btn:hover {
  background: rgba(255, 255, 255, 0.4);
}

.carousel-btn.prev {
  left: 20px;
}

.carousel-btn.next {
  right: 20px;
}

/* 步骤指南 */
.ds-steps {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 20px;
}

.ds-step {
  border-radius: 15px;
  overflow: hidden;
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.05);
  transition: all 0.3s;
  background-color: #f9f9ff;
}

.ds-step:hover {
  transform: translateY(-5px);
  box-shadow: 0 6px 15px rgba(106, 90, 205, 0.2);
}

.ds-step-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px;
  background-color: #e8e8ff;
}

.ds-step-badge {
  font-size: 0.9rem;
  font-weight: 600;
  color: #6a5acd;
  background-color: #f0f0ff;
  padding: 5px 10px;
  border-radius: 10px;
}

.ds-step-decorator {
  width: 12px;
  height: 12px;
  background-color: #ff9eb5;
  border-radius: 50%;
}

.ds-step-image {
  width: 100%;
  height: 180px;
  object-fit: cover;
  margin-bottom: -5px;
}

.ds-step-content {
  padding: 15px;
}

.ds-step-description {
  font-size: 0.95rem;
  line-height: 1.6;
  color: #555;
}

/* 联系我们 */
.contact-section {
  text-align: center;
}

.contact-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
}

.contact-slogan {
  font-size: 1.3em;
  font-weight: bold;
  color: #6a5acd;
  margin-bottom: 10px;
}

.dy-info {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;
}

.dy-name {
  font-size: 1.1em;
  color: #555;
  font-weight: 500;
}

.dy-qrcode {
  margin: 15px 0;
}

.qrcode-image {
  width: 200px;
  height: 240px;
  border-radius: 15px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s;
}

.qrcode-image:hover {
  transform: scale(1.05);
}

/* AI生图模块 */
.image-generator-section {
  background: linear-gradient(135deg, #f9f9ff 0%, #f0f0ff 100%);
}

.generator-content {
  text-align: center;
}

.generator-features {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
  margin-bottom: 30px;
}

.feature-card {
  background-color: white;
  border-radius: 15px;
  padding: 25px;
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
}

.feature-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 20px rgba(106, 90, 205, 0.15);
}

.feature-icon {
  font-size: 40px;
  margin-bottom: 15px;
}

.feature-card h4 {
  margin: 0 0 10px 0;
  color: #6a5acd;
  font-size: 16px;
}

.feature-card p {
  margin: 0;
  color: #666;
  font-size: 14px;
  line-height: 1.6;
}

.generator-action {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
}

.generator-btn {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 15px 40px;
  background: linear-gradient(135deg, #6a5acd 0%, #9370db 100%);
  color: white;
  border: none;
  border-radius: 30px;
  font-size: 18px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(106, 90, 205, 0.3);
}

.generator-btn:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 25px rgba(106, 90, 205, 0.4);
}

.generator-btn .btn-icon {
  font-size: 24px;
}

.generator-tip {
  margin: 0;
  color: #999;
  font-size: 14px;
}

/* 项目进展 */
.project-section {
  margin-top: 40px;
}

.project-timeline {
  position: relative;
  max-width: 800px;
  margin: 0 auto;
  padding: 20px 0;
}

.project-timeline::before {
  content: '';
  position: absolute;
  top: 0;
  left: 20px;
  height: 100%;
  width: 4px;
  background: linear-gradient(to bottom, #e8e8ff, #6a5acd);
  border-radius: 2px;
}

.milestone {
  position: relative;
  padding-left: 50px;
  margin-bottom: 30px;
  animation: fadeInUp 0.6s ease-out;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.milestone-content {
  background-color: #f9f9ff;
  border-radius: 15px;
  padding: 15px 20px;
  box-shadow: 0 3px 10px rgba(106, 90, 205, 0.1);
  transition: all 0.3s ease;
}

.milestone-content:hover {
  transform: translateY(-3px);
  box-shadow: 0 6px 15px rgba(106, 90, 205, 0.2);
}

.milestone-date {
  font-weight: 600;
  color: #6a5acd;
  font-size: 0.85rem;
  margin-bottom: 10px;
  text-align: left;
}

.milestone-title {
  margin: 0 0 8px 0;
  color: #333;
  font-size: 1.1rem;
}

.milestone-description {
  margin: 0;
  color: #666;
  font-size: 0.95rem;
  line-height: 1.5;
}

.milestone-dot {
  position: absolute;
  left: 16px;
  top: 18px;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: #e8e8ff;
  border: 3px solid #6a5acd;
  z-index: 1;
}

.milestone-dot.active {
  background-color: #6a5acd;
  box-shadow: 0 0 0 4px rgba(106, 90, 205, 0.2);
}

/* 响应式设计 */
@media (max-width: 768px) {
  .container {
    padding: 10px;
    margin: 0;
    border-radius: 0;
  }

  .header {
    padding: 8px 16px;
    border-radius: 0;
  }

  .logo {
    width: 40px;
    height: 40px;
  }

  .header-content {
    flex-direction: row;
    align-items: center;
    text-align: left;
    gap: 10px;
  }

  .app-info {
    justify-content: flex-start;
    flex: 1;
    margin-bottom: 0;
    gap: 8px;
  }

  .title {
    font-size: 16px;
    max-width: calc(100vw - 190px);
  }

  .tabs {
    display: flex;
    gap: 4px;
    max-width: none;
    width: auto;
    margin-top: 0;
  }

  .tab-item {
    width: auto;
    min-height: 42px;
    padding: 9px 10px;
    border-radius: 10px;
    font-size: 14px;
  }

  .profile-menu {
    width: auto;
    padding-bottom: 0;
  }

  .profile-trigger {
    width: auto;
    max-width: 142px;
    min-height: 42px;
    border-radius: 10px;
  }

  .profile-dropdown {
    right: 0;
    left: auto;
    top: calc(100% - 4px);
    width: 172px;
  }

  .profile-dropdown button {
    padding: 11px 12px;
    text-align: center;
  }

  .carousel-item {
    flex-direction: column;
  }

  .carousel-content {
    width: calc(100% - 24px);
    gap: 12px;
    padding: 72px 12px 20px;
  }

  .banner-icon {
    width: 96px;
    margin-bottom: 6px;
  }

  .banner-title-image {
    width: min(300px, 88vw);
    margin-bottom: 8px;
  }

  .banner-nav {
    gap: 6px;
    width: 100%;
  }

  .banner-nav-item {
    min-height: 64px;
    padding: 8px 4px;
    font-size: 12px;
  }

  .banner-nav-icon {
    font-size: 18px;
  }

  .carousel-text {
    padding-right: 0;
    margin-bottom: 15px;
  }

  .carousel-image {
    width: 100%;
    max-width: 300px;
  }

  .ds-steps {
    grid-template-columns: 1fr;
  }

  .contact-slogan {
    font-size: 1.1em;
  }

  .dy-name {
    font-size: 1em;
  }

  .qrcode-image {
    width: 180px;
    height: 180px;
  }

  .project-timeline {
    padding-left: 20px;
  }

  .project-timeline::before {
    left: 15px;
  }

  .milestone {
    padding-left: 40px;
  }

  .milestone-date {
    font-size: 0.8rem;
    margin-bottom: 8px;
  }

  .milestone-dot {
    left: 11px;
    top: 15px;
  }

  .milestone-title {
    font-size: 1rem;
  }

  .milestone-description {
    font-size: 0.9rem;
  }
}

/* 页脚 */
.footer {
  text-align: center;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.6);
  padding: 20px 10px;
  background: rgba(10, 14, 39, 0.95);
  border-top: 1px solid rgba(0, 255, 255, 0.1);
}

.footer p {
  margin: 5px 0;
}

/* 友情链接 */
.friend-link {
  position: fixed;
  right: 30px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 100;
  display: block;
}

.friend-link-img {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
  transition: transform 0.3s, box-shadow 0.3s;
}

.friend-link-img:hover {
  transform: scale(1.1);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.4);
}

/* 邀请码提示弹窗 */
.invite-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.invite-modal {
  background: #fff;
  border-radius: 16px;
  width: 90%;
  max-width: 400px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
}

.invite-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  border-bottom: 1px solid #eee;
}

.invite-modal-header h3 {
  margin: 0;
  font-size: 18px;
  color: #333;
}

.invite-modal-header .close-btn {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #999;
  padding: 0;
  line-height: 1;
}

.invite-modal-header .close-btn:hover {
  color: #333;
}

.invite-modal-body {
  padding: 20px;
}

.invite-modal-body p {
  margin: 0 0 15px 0;
  color: #666;
  font-size: 14px;
  line-height: 1.6;
}

.contact-info {
  background: #f9f9ff;
  border-radius: 12px;
  padding: 15px;
  margin-bottom: 15px;
}

.contact-item {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
}

.contact-label {
  font-weight: bold;
  color: #6a5acd;
}

.qrcode-container {
  text-align: center;
  margin-top: 15px;
}

.modal-qrcode {
  width: 150px;
  height: 150px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.qrcode-tip {
  margin-top: 8px !important;
  color: #999;
  font-size: 12px !important;
}

.invite-modal-actions {
  display: flex;
  gap: 10px;
}

.invite-modal-actions button {
  flex: 1;
  padding: 12px;
  border-radius: 8px;
  font-size: 14px;
  cursor: pointer;
  border: none;
  transition: all 0.3s;
}

.invite-modal-actions .primary-btn {
  background: linear-gradient(135deg, #6a5acd, #8b5cf6);
  color: #fff;
}

.invite-modal-actions .primary-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(106, 90, 205, 0.4);
}

.invite-modal-actions .secondary-btn {
  background: #f0f0f0;
  color: #666;
}

.invite-modal-actions .secondary-btn:hover {
  background: #e0e0e0;
}

/* Homepage product showcase */
.scroll-view {
  max-width: none;
  padding: 0 0 84px;
  background: #f4f6f8;
}

.scroll-view h2,
.scroll-view h3,
.scroll-view p,
.scroll-view span,
.scroll-view button {
  letter-spacing: 0;
}

.capability-intro,
.section,
.community-band {
  width: min(1200px, calc(100% - 48px));
  box-sizing: border-box;
  margin-right: auto;
  margin-left: auto;
}

.capability-intro {
  padding: 52px 32px 40px;
}

.intro-copy h2,
.product-section-heading h2,
.showcase-copy h2,
.community-band h2 {
  margin: 8px 0 14px;
  color: #18212b;
  font-size: 36px;
  line-height: 1.22;
}

.intro-copy p,
.product-section-heading p,
.showcase-lead,
.community-band p {
  margin: 0;
  color: #606b76;
  font-size: 16px;
  line-height: 1.75;
}

.section-kicker {
  color: #087da7;
  font-size: 12px;
  font-weight: 800;
  text-transform: uppercase;
}

.section {
  margin-bottom: 0;
  padding: 72px 32px;
  border-bottom: 1px solid #dce1e6;
  border-radius: 0;
  background: transparent;
  box-shadow: none;
}

.product-section-heading {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 42px;
  margin-bottom: 30px;
}

.product-section-heading > div { max-width: 720px; }
.product-section-heading h2 { font-size: 32px; }

.section-action,
.showcase-action {
  min-height: 44px;
  padding: 0 18px;
  border: 1px solid #087da7;
  border-radius: 6px;
  background: #087da7;
  color: #fff;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 9px;
  font: inherit;
  font-size: 14px;
  font-weight: 700;
  white-space: nowrap;
  transition: background .2s, transform .2s, box-shadow .2s;
}

.section-action:hover,
.showcase-action:hover {
  transform: translateY(-2px);
  background: #066888;
  box-shadow: 0 9px 22px rgba(8, 125, 167, .2);
}

.ds-steps {
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 16px;
}

.ds-step {
  border: 1px solid #dce1e6;
  border-radius: 8px;
  background: #fff;
  box-shadow: none;
  overflow: hidden;
}

.ds-step:hover {
  transform: translateY(-3px);
  border-color: #9ac4d3;
  box-shadow: 0 12px 26px rgba(26, 42, 55, .08);
}

.ds-step-media { position: relative; height: 218px; overflow: hidden; background: #e9edf0; }
.ds-step-image { width: 100%; height: 100%; margin: 0; object-fit: cover; object-position: top center; transition: transform .35s ease; }
.ds-step:hover .ds-step-image { transform: scale(1.025); }
.ds-step-index { position: absolute; left: 12px; bottom: 12px; width: 36px; height: 36px; border-radius: 50%; background: rgba(20, 29, 38, .88); color: #fff; display: grid; place-items: center; font-size: 12px; font-weight: 800; }
.ds-step-content { min-height: 92px; padding: 17px 18px 19px; }
.ds-step-content h3 { margin: 0 0 7px; color: #202a34; font-size: 15px; }
.ds-step-description { color: #67727d; font-size: 13px; line-height: 1.55; }

.coloring-workflow .section-kicker { color: #c14f37; }
.coloring-workflow .section-action { border-color: #c6533b; background: #c6533b; }
.coloring-workflow .section-action:hover { background: #a94330; box-shadow: 0 9px 22px rgba(198, 83, 59, .18); }
.coloring-workflow .ds-step:hover { border-color: #e2a291; }

.showcase-section { padding-top: 86px; padding-bottom: 86px; }
.showcase-grid { display: grid; grid-template-columns: minmax(0, 1.08fr) minmax(360px, .92fr); gap: 64px; align-items: center; }
.showcase-grid.reverse { grid-template-columns: minmax(360px, .92fr) minmax(0, 1.08fr); }
.showcase-grid.reverse .showcase-visual { order: 2; }
.showcase-copy h2 { font-size: 34px; }
.showcase-lead { margin-bottom: 26px; }
.showcase-visual { position: relative; min-width: 0; border: 1px solid #cfd6dd; border-radius: 8px; background: #fff; box-shadow: 0 20px 50px rgba(24, 33, 43, .13); overflow: hidden; }

.generation-visual { aspect-ratio: 4 / 3; background: #151b21; }
.generation-visual > img { width: 100%; height: 100%; display: block; object-fit: cover; object-position: center; }
.generation-visual::after { content: ''; position: absolute; inset: 0; border: 1px solid rgba(255,255,255,.18); pointer-events: none; }
.extreme-color-section .section-kicker,
.extreme-color-section .feature-list i { color: #c6533b; }
.extreme-color-visual { aspect-ratio: 4 / 3; background: #151716; }
.extreme-color-visual > img { width: 100%; height: 100%; display: block; object-fit: cover; object-position: center; }
.extreme-color-visual::after { content: ''; position: absolute; inset: 0; border: 1px solid rgba(255,255,255,.16); pointer-events: none; }
.extreme-color-action { border-color: #c6533b; background: #c6533b; }
.extreme-color-action:hover { background: #a94330; box-shadow: 0 9px 22px rgba(198, 83, 59, .2); }
.visual-meta { position: absolute; z-index: 2; padding: 8px 11px; border-radius: 5px; background: rgba(17, 24, 31, .82); color: #fff; backdrop-filter: blur(8px); font-size: 11px; font-weight: 700; }
.visual-meta-top { top: 14px; left: 14px; }
.visual-meta-bottom { right: 14px; bottom: 14px; }

.feature-list { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); margin: 0 0 28px; border-top: 1px solid #dce1e6; }
.feature-list > div { min-width: 0; padding: 16px 12px 16px 0; border-bottom: 1px solid #dce1e6; display: flex; gap: 11px; }
.feature-list > div:nth-child(odd) { border-right: 1px solid #dce1e6; }
.feature-list > div:nth-child(even) { padding-left: 16px; }
.feature-list i { width: 28px; flex: none; margin-top: 2px; color: #087da7; font-size: 15px; }
.feature-list span { min-width: 0; display: flex; flex-direction: column; gap: 4px; }
.feature-list b { color: #26313b; font-size: 13px; }
.feature-list small { color: #727e89; font-size: 11px; line-height: 1.45; }

.inspiration-section .section-kicker,
.inspiration-section .feature-list i { color: #3b7c57; }
.board-action { border-color: #3b7c57; background: #3b7c57; }
.board-action:hover { background: #306747; box-shadow: 0 9px 22px rgba(59, 124, 87, .2); }

.board-visual { background: #edf0f2; }
.board-preview-toolbar { height: 48px; padding: 0 15px; border-bottom: 1px solid #d3d9df; background: #fff; display: flex; align-items: center; gap: 18px; color: #4d5863; font-size: 11px; }
.board-preview-toolbar span { display: flex; align-items: center; gap: 5px; }
.board-preview-toolbar b { margin-left: auto; color: #1f2a34; }
.board-preview-body { height: 354px; padding: 14px; display: grid; grid-template-columns: minmax(0, 1fr) 122px; gap: 12px; }
.board-preview-canvas { position: relative; min-width: 0; border: 1px solid #cbd2d9; background: #fff; overflow: hidden; }
.board-preview-canvas img { width: 100%; height: 100%; display: block; object-fit: cover; object-position: 42% center; }
.canvas-selection { position: absolute; inset: 16% 19% 13% 15%; border: 2px dashed #13a7c4; box-shadow: 0 0 18px rgba(19, 167, 196, .38); }
.board-preview-layers { padding: 12px 8px; border: 1px solid #d3d9df; background: #fff; display: flex; flex-direction: column; gap: 7px; }
.board-preview-layers strong { padding: 0 5px 8px; border-bottom: 1px solid #e1e5e9; color: #333e48; font-size: 12px; }
.board-preview-layers span { min-width: 0; padding: 8px 6px; border: 1px solid transparent; border-radius: 4px; color: #68737d; display: flex; align-items: center; gap: 6px; font-size: 10px; white-space: nowrap; }
.board-preview-layers span.active { border-color: #9dcfb1; background: #eef8f2; color: #306747; }
.board-preview-layers i { width: 22px; height: 22px; flex: none; border: 1px solid #d5dbe0; background: repeating-conic-gradient(#e3e7ea 0 25%, #fff 0 50%) 50% / 8px 8px; }

.community-band { min-height: 220px; margin-top: 72px; padding: 34px 42px; border-radius: 8px; background: #19242d; color: #fff; display: flex; align-items: center; justify-content: space-between; gap: 42px; }
.community-band .section-kicker { color: #63c9de; }
.community-band h2 { color: #fff; font-size: 28px; }
.community-band p { color: #b9c4cc; font-size: 14px; }
.community-contact { flex: none; display: flex; align-items: center; gap: 14px; color: #dfe7ec; font-size: 12px; }
.community-contact .qrcode-image { width: 180px; height: auto; margin: 0; border: 5px solid #fff; border-radius: 6px; object-fit: contain; box-shadow: none; }
.community-contact .qrcode-image:hover { transform: none; }

.project-section { margin-top: 0; padding-top: 86px; border-bottom: 0; }
.project-heading { align-items: center; }
.project-status { flex: none; padding: 8px 11px; border: 1px solid #b9d7c4; border-radius: 16px; background: #edf7f1; color: #356d4d; font-size: 12px; font-weight: 700; }
.project-status i { width: 7px; height: 7px; margin-right: 6px; border-radius: 50%; background: #3b8c5d; display: inline-block; animation: project-pulse 1.8s ease-in-out infinite; }
@keyframes project-pulse { 50% { box-shadow: 0 0 0 5px rgba(59, 140, 93, .14); } }

.project-timeline { max-width: none; padding: 8px 0 0; display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 0 42px; }
.project-timeline::before { content: none; }
.milestone { min-width: 0; min-height: 150px; margin: 0; padding: 24px 0; border-top: 1px solid #d7dde3; display: grid; grid-template-columns: 54px minmax(0, 1fr); gap: 14px; animation: none; }
.milestone-rail { display: flex; flex-direction: column; align-items: center; gap: 9px; }
.milestone-dot { position: static; width: 11px; height: 11px; box-sizing: border-box; border: 2px solid #85919c; background: #fff; }
.milestone-dot.active { border-color: #087da7; background: #087da7; box-shadow: 0 0 0 5px rgba(8, 125, 167, .12); }
.milestone-index { color: #9aa4ad; font-size: 10px; font-weight: 800; }
.milestone-content { padding: 0; border-radius: 0; background: transparent; box-shadow: none; }
.milestone-content:hover { transform: none; box-shadow: none; }
.milestone-date { margin: 0 0 7px; color: #087da7; font-size: 11px; }
.milestone-title { margin: 0 0 7px; color: #25303a; font-size: 16px; }
.milestone-description { color: #6c7781; font-size: 13px; line-height: 1.6; }
.milestone.upcoming { opacity: .72; }
.friend-link { right: 10px; }
.friend-link-img { width: 46px; height: 46px; }

@media (max-width: 960px) {
  .showcase-grid,
  .showcase-grid.reverse { grid-template-columns: 1fr; gap: 38px; }
  .showcase-grid.reverse .showcase-visual { order: 0; }
  .showcase-copy { max-width: 720px; }
  .project-timeline { grid-template-columns: 1fr; }
}

@media (max-width: 768px) {
  .container { padding: 0; }
  .scroll-view { padding-bottom: 46px; }
  .capability-intro,
  .section,
  .community-band { width: calc(100% - 24px); }
  .capability-intro { padding: 58px 4px 42px; }
  .intro-copy h2,
  .product-section-heading h2,
  .showcase-copy h2 { font-size: 27px; }
  .intro-copy p,
  .product-section-heading p,
  .showcase-lead { font-size: 14px; }
  .section { padding: 54px 4px; }
  .product-section-heading { align-items: flex-start; flex-direction: column; gap: 20px; margin-bottom: 24px; }
  .section-action { width: 100%; }
  .ds-steps { grid-template-columns: 1fr; gap: 12px; }
  .ds-step { display: grid; grid-template-columns: 42% minmax(0, 1fr); min-height: 132px; }
  .ds-step-media { height: 100%; min-height: 132px; }
  .ds-step-content { min-height: 0; padding: 18px 14px; align-self: center; }
  .ds-step-index { left: 8px; bottom: 8px; width: 30px; height: 30px; }
  .showcase-section { padding-top: 58px; padding-bottom: 58px; }
  .showcase-grid { gap: 28px; }
  .feature-list { grid-template-columns: 1fr; }
  .feature-list > div:nth-child(odd) { border-right: 0; }
  .feature-list > div:nth-child(even) { padding-left: 0; }
  .showcase-action { width: 100%; }
  .board-preview-body { height: 290px; grid-template-columns: minmax(0, 1fr) 92px; padding: 8px; gap: 7px; }
  .board-preview-toolbar { gap: 10px; padding: 0 10px; }
  .board-preview-toolbar span:nth-child(2) { display: none; }
  .board-preview-layers { padding: 8px 4px; }
  .board-preview-layers span { padding: 6px 3px; font-size: 9px; }
  .board-preview-layers i { width: 16px; height: 16px; }
  .community-band { min-height: 0; margin-top: 42px; padding: 28px 20px; align-items: flex-start; flex-direction: column; gap: 22px; }
  .community-band h2 { font-size: 23px; }
  .community-contact { width: 100%; }
  .community-contact .qrcode-image { width: 90px; height: auto; }
  .project-section { padding-top: 60px; }
  .project-heading { gap: 18px; }
  .project-timeline { padding-left: 0; }
  .milestone { min-height: 0; grid-template-columns: 44px minmax(0, 1fr); padding: 20px 0; }
  .friend-link { display: none; }
}

/* Model workshop identity: armor white / cobalt / signal red. */
.container { --mecha-blue: #28549a; --mecha-red: #c83948; --mecha-ink: #183153; }
.scroll-view { background: #fff; }
.header.scrolled { background: rgba(255,255,255,.97); }
.banner-nav-art { width: 64px; height: 64px; border-radius: 10px; object-fit: contain; background: #f4f7fc; }
.showcase-copy h2, .intro-copy h2, .product-section-heading h2 { color: var(--mecha-ink); }
.section-kicker, .extreme-color-section .section-kicker { color: var(--mecha-red); }
.section-action, .showcase-action, .extreme-color-action { background: var(--mecha-blue); border-color: var(--mecha-blue); color: #fff; }
.extreme-color-action { background: var(--mecha-red); border-color: var(--mecha-red); }
.section-action:hover, .showcase-action:hover { background: #1c3e76; }
.extreme-color-action:hover { background: #a72b3a; }
.extreme-color-section, .ai-generator-section { background: #fff; }
.extreme-color-visual, .generation-visual { background: #f4f7fc; border: 1px solid #d4dfee; border-radius: 14px; }
.extreme-color-visual img, .generation-visual img { object-fit: contain; }
.feature-list > div > i { color: var(--mecha-blue); background: #eaf0fb; }
.banner-nav-item { border-color: #ffffff40; }
.container button:focus-visible { outline: 3px solid #638dd1; outline-offset: 4px; }
@media (max-width: 600px) { .banner-nav-art { width: 48px; height: 48px; } }
@media (prefers-reduced-motion: reduce) { .container *, .container *::before { animation: none !important; transition: none !important; } }


/* White-first home with restrained cobalt and red accents. */
.container { background: #fff; padding: 0; color: var(--mecha-ink); font-family: "Segoe UI", "Microsoft YaHei", sans-serif; }
.header, .header.scrolled { background: rgba(255,255,255,.97); border-bottom: 1px solid #e0e6ef; box-shadow: none; }
.header .logo { box-shadow: none; border-radius: 5px; }
.profile-trigger:hover, .profile-menu:focus-within .profile-trigger { background: #edf3fc; }
.profile-dropdown { background: #fff; border-color: #d4dfee; }
.profile-dropdown button { color: var(--mecha-ink); }
.profile-dropdown button:hover { background: #edf3fc; color: var(--mecha-blue); }
.profile-trigger::after, .tab-item::after { background: var(--mecha-red); }
.white-hero { max-width: 1440px; margin: 0 auto; padding: 110px 5.5% 40px; box-sizing: border-box; background: #fff; }
.public-guide-entry { display:flex; align-items:center; flex-wrap:wrap; gap:6px 10px; margin:16px 0 0; font-size:13px; line-height:1.8; color:#526780; }.public-guide-entry a,.feature-guide-link { color:#28549a; text-underline-offset:4px; }.public-guide-entry a { display:inline-flex; align-items:center; min-height:44px; }.public-guide-entry span { font-size:12px; color:#62778e; }.feature-guide-link { display:inline-flex; align-items:center; min-height:44px; margin:5px 0 10px; font-size:13px; line-height:1.8; }.public-guide-entry a:hover,.feature-guide-link:hover { color:#b32d44; }
#row3 { scroll-margin-top: 90px; }
.workspace-entry-heading { margin-top: 32px; display: flex; flex-wrap: wrap; align-items: baseline; justify-content: space-between; gap: 8px 20px; }
.workspace-entry-heading h2 { margin: 0; font-size: 20px; color: var(--mecha-ink); }
.workspace-entry-heading p { margin: 0; font-size: 14px; color: #52627a; line-height: 1.6; }
.hero-workspaces { margin-top: 14px; display: grid; grid-template-columns: repeat(5,minmax(0,1fr)); border: 1px solid #dce4f0; border-radius: 10px; overflow: hidden; }
.hero-workspaces button { min-width: 0; min-height: 122px; display: flex; gap: 10px; align-items: center; padding: 16px 10px; border: 0; border-right: 1px solid #e0e7f1; background: #fff; color: var(--mecha-ink); text-align: left; cursor: pointer; transition: background-color .15s ease; }
.hero-workspaces button:last-child { border-right: 0; }
.hero-workspaces button:hover { background: #f3f6fc; }
.hero-workspaces button:focus-visible { outline: 3px solid var(--mecha-blue); outline-offset: -3px; background: #f3f6fc; }
.hero-workspaces img { width: 52px; height: 52px; flex-shrink: 0; object-fit: contain; border-radius: 6px; }
.hero-workspaces span { min-width: 0; }
.hero-workspaces b { display: block; font-size: 14px; }
.hero-workspaces small { display: block; margin-top: 5px; font-size: 12px; color: #52627a; line-height: 1.6; }
.hero-workspaces em { display: flex; align-items: center; gap: 8px; margin-top: 10px; font-size: 12px; font-style: normal; font-weight: 700; color: var(--mecha-blue); }
.hero-workspaces em i { font-size: 10px; }
.hero-workspaces button:hover em, .hero-workspaces button:focus-visible em { color: var(--mecha-red); }
.capability-intro, .section { background: #fff; border-color: #e2e8f1; }
.capability-intro { border-top: 1px solid #e2e8f1; }
.ds-step-index { background: var(--mecha-blue); }
.coloring-workflow .section-action, .extreme-color-action { background: var(--mecha-red); border-color: var(--mecha-red); }
.coloring-workflow .section-action:hover, .extreme-color-action:hover { background: #a72b3a; box-shadow: none; }
.inspiration-section .section-kicker, .community-band .section-kicker { color: var(--mecha-red); }
.inspiration-section .feature-list i, .milestone-date { color: var(--mecha-blue); }
.board-action { border-color: var(--mecha-blue); background: var(--mecha-blue); }
.board-action:hover { background: #1c3e76; box-shadow: none; }
.board-preview-layers span.active { border-color: #c7d5e9; background: #edf3fc; color: var(--mecha-blue); }
.canvas-selection { border-color: var(--mecha-blue); box-shadow: none; }
.visual-meta { background: rgba(255,255,255,.94); border: 1px solid #d4dfee; color: var(--mecha-blue); backdrop-filter: none; }
.community-band { background: #fff; color: var(--mecha-ink); border: 1px solid #d4dfee; border-left: 4px solid var(--mecha-red); }
.community-band h2 { color: var(--mecha-ink); }
.community-band p, .community-contact { color: #52627a; }
.project-status { border-color: #cad8ed; background: #f0f5fd; color: var(--mecha-blue); }
.project-status i { background: var(--mecha-red); animation: none; }
.milestone-dot.active { background: var(--mecha-blue); border-color: var(--mecha-blue); box-shadow: 0 0 0 4px #edf3fc; }
.footer { background: #fff; border-top: 1px solid #e0e6ef; }
.footer p { color: #61738c; }
.account-actions .primary, .invite-modal-actions .primary-btn { background: var(--mecha-blue); }
.invite-modal .contact-info { background: #f5f8fd; }
@media (max-width: 1100px) and (min-width: 981px) { .hero-workspaces img { width: 42px; height: 42px; } .hero-workspaces button { gap: 8px; padding: 14px 8px; } }
@media (max-width: 980px) { .hero-workspaces { grid-template-columns: repeat(3,minmax(0,1fr)); } .hero-workspaces button { border-bottom: 1px solid #e0e7f1; } }
@media (max-width: 768px) {
 .white-hero { padding: 100px 20px 28px; }
 .workspace-entry-heading { margin-top: 24px; } .workspace-entry-heading h2 { font-size: 18px; } .hero-workspaces { grid-template-columns: 1fr 1fr; }
 .hero-workspaces button:last-child { grid-column: span 2; } .hero-workspaces button { min-height: 122px; padding: 14px 10px; }
 .hero-workspaces img { width: 42px; height: 42px; }
 .header { padding-left: 16px; padding-right: 16px; } .header .title { font-size: 16px; }
 .header .app-info { gap: 8px; } .header .profile-trigger { padding: 0 6px; max-width: 120px; }
}


.header .tabs{display:flex;align-items:center;gap:14px;flex-shrink:0}.rewards-trigger{display:inline-flex;align-items:center;gap:8px;min-height:44px;padding:6px 12px;border:1px solid #f1d6da;border-radius:7px;background:#fff8f9;color:#a82b42;font:inherit;font-size:14px;font-weight:600;white-space:nowrap;cursor:pointer}.rewards-trigger:hover{background:#fff0f3;border-color:#ddaab4}.rewards-gift{position:relative;display:inline-flex;align-items:center;justify-content:center;width:27px;height:28px;transform-origin:50% 80%;color:#c3344d;font-size:22px}.rewards-dot{position:absolute;right:-2px;top:-2px;width:7px;height:7px;border:2px solid #fff8f9;border-radius:50%;background:#e83843;box-shadow:0 0 0 1px #ffd69b}.has-reward .rewards-gift{animation:rewards-shake 5.2s ease-in-out infinite}.rewards-trigger:focus-visible .rewards-gift,.rewards-trigger:hover .rewards-gift{animation-play-state:paused}@keyframes rewards-shake{0%,14%,100%{transform:rotate(0)}2%{transform:rotate(-13deg)}4%{transform:rotate(11deg)}6%{transform:rotate(-9deg)}8%{transform:rotate(7deg)}10%{transform:rotate(-4deg)}12%{transform:rotate(2deg)}}@media(max-width:600px){.header .brand-wordmark{display:none}.header .title{display:none}.header .tabs{gap:8px}.rewards-trigger{padding:5px 8px;font-size:13px;gap:6px}.header .profile-trigger{max-width:100px}.header .app-info{flex:1}}@media(prefers-reduced-motion:reduce){.has-reward .rewards-gift{animation:none}}
.header-nav{margin-left:auto;flex-shrink:0}.header-paint-link{display:inline-flex;align-items:center;min-height:44px;padding:0 12px;color:#28549a;font-size:14px;font-weight:600;text-decoration:none;white-space:nowrap;border-radius:5px}.header-paint-link:hover{background:#edf3fc;text-decoration:underline;text-underline-offset:5px}.header-paint-link:focus-visible{outline:3px solid #7b9fd1;outline-offset:2px}
@media(max-width:600px){.header-content{gap:6px}.header .app-info{flex:0 0 auto}.header .tabs{gap:4px}.header-paint-link{padding:0 4px;font-size:13px}.header .profile-display-name,.header .login-prefix{display:none}.header .profile-trigger{min-width:44px;min-height:44px;padding:0;gap:0}.header .login-btn{min-width:44px;padding:0 4px}.header-nav{margin-left:auto}}
@media(max-width:360px){.header{padding-left:8px;padding-right:8px}.header-paint-link{font-size:12px;padding:0 3px}.rewards-trigger{gap:4px;padding:5px 6px}.rewards-gift{width:22px}}

.header-square-link{gap:7px}.header-square-icon{display:inline-flex;align-items:center;justify-content:center;width:28px;height:28px;background:linear-gradient(135deg,#e5f0ff,#d5e6ff);border:1px solid #c9ddfc;border-radius:8px;color:#2865c7;font-size:14px}.header-square-link:hover .header-square-icon{background:#d5e6ff}
@media(max-width:600px){.header-square-link{gap:4px}.header-square-icon{width:25px;height:25px;font-size:13px}.header .rewards-trigger{width:44px;height:44px;justify-content:center;padding:0}.header .rewards-trigger>span:last-child{display:none}}

.profile-dropdown>a{display:block;padding:12px 16px;text-decoration:none;color:#20354d;font-size:14px}.profile-dropdown>a:hover{background:#edf3fc}
@media(max-width:600px){.header-nav{display:flex;gap:2px}.header-nav .header-paint-link[href="#paint-color-cards"]{display:none}.header .tabs .notification-bell{width:44px;min-width:44px;height:44px;border-radius:10px}}
</style>
